import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import { surveyDistributionOptionsArray, bareBrandedOptionsArray, smsOrEmailArray, mspPlatformArray } from './SharedConstants';

const employeeSurveyPages = [
  {
    label: 'Program Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.EmployeeSurvey,
    fields: [
      {
        fieldName: 'Objective',
        label: 'Objective',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'Frequency',
        label: 'Frequency',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'TargetAudience',
        label: 'Target Audience (Location, Gender, Age, Profession, Income, Other)',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'TargetNumResponses',
        label: 'Target Number of Responses?',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'DistributionOfSurvey',
        label: 'Distribution of Survey',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: surveyDistributionOptionsArray,
      },
      {
        fieldName: 'BareOrClientSend',
        label: 'Does BARE send or does the Client send?',
        className: 'col-12',
        type: InputTypesEnum.EmptyYesNoSelect,
      },
      {
        fieldName: 'SmsorEmailForBare',
        label: 'If BARE sends, SMS or Email?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(smsOrEmailArray.map((s) => s.label)),
        hide: (item) => item.BareOrClientSend !== 'true',
      },
      {
        fieldName: 'FrequencyOfSurvey',
        label: 'Frequency of Survey?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'DurationOfSurvey',
        label: 'Duration of Survey',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'PreferredTimeline',
        label: 'Preferred timeline of starting and receiving the results',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'BareBrandedOrCompanyBranded',
        label: 'Bare Branded or Company Branded?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(bareBrandedOptionsArray.map((b) => b.label)),
      },
      {
        fieldName: 'EmployeesEnterName',
        label: 'Do employees enter their name?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'IncentivesDescription',
        label: 'Incentives (please describe)?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
  {
    label: 'Survey',
    hide: (item) => item.TypeCode != ServiceTypeEnum.EmployeeSurvey,
    fields: [
      {
        fieldName: 'NumClosedQuestions',
        label: 'No. Closed Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumOpenQuestions',
        label: 'No. Simple Text Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumNarrativeQuestions',
        label: 'No. Narrative Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'QuestionnaireProvided',
        label: 'Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'CollaborationInDataSoftware',
        label: 'Will Collaboration be used in Data Software?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'Mspplatform',
        label: 'MSP Platform',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(mspPlatformArray.map((m) => m.label)),
        hide: (item) => item.CollaborationInDataSoftware !== 'true',
      },
      {
        fieldName: 'RequiredLanguageCode',
        label: 'Required Language(s) reporting',
        className: 'col-12',
        type: InputTypesEnum.LanguageMultiSelect,
      },
      {
        fieldName: 'DataCaptureMethodCode',
        label: 'Data Capture Method',
        className: 'col-6',
        type: InputTypesEnum.CommonDataCaptureMethodLookupItemSelect,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'OtherDataCaptureMethod',
        label: 'Other Data Capture Method Description',
        className: 'col-6',
        type: InputTypesEnum.Text,
        // validityChecker: EditServiceDescription.validityCheckerforOtherDataCaptureMethodDescription, // TODO:
        hide: (item) => item.DataCaptureMethodCode != 3,
      },
    ],
  },
];

export default employeeSurveyPages;
